
import { defineComponent, SetupContext, PropType, ref, computed, ComponentPublicInstance, onMounted } from "vue";
import FridgeDetailsSelectDateBarItem from "@/components/fridgeDetails/FridgeDetailsSelectDateBarItem.vue";
import NativeClient from "@/client/native-client";

export default defineComponent({
  name: "FridgeDetailsSelectDateBar",
  components: { FridgeDetailsSelectDateBarItem },
  props: {
    /** 表示する文字列 */
    dateList: {
      type: Array as PropType<string[]>,
      required: true
    },
    /** 表示タイプ（0：日付、1：期間） */
    type: {
      type: Number,
      default: 0
    },
    selectIndex: {
      type: Number,
      default: 0
    },
    isDisableButtonHidden: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("FridgeDetailsSelectDateBar setup start");
    // 表示更新のためのリアクティブ
    const updateDisplayKey = ref(0);
    const updateDisplay = () => {
      if (updateDisplayKey.value == 100) {
        updateDisplayKey.value = 0;
      } else {
        updateDisplayKey.value++;
      }
    };

    // 設定値
    const selectDateIndex = ref(props.selectIndex);

    const calcContentsWidth = () => {
      let contentsWidth = `20rem`;
      switch (props.type) {
        case 0:
          contentsWidth = `8.4rem`;
          break;
        case 1:
          contentsWidth = `15rem`;
          break;
        case 2:
          {
            const stringWidth = window.innerWidth / 10 - 1.6 - 8.8;
            contentsWidth = `${stringWidth}rem`;
          }
          break;
        default:
          break;
      }
      return contentsWidth;
    };

    // 表示タイプによるサイズの変更
    const styleContentSize = computed(() => {
      const contentsWidth = calcContentsWidth();
      return { width: contentsWidth, height: '4.4rem' };
    });
    const styleItems = computed(() => {
      const contentsWidth = calcContentsWidth();
      return { width: contentsWidth, height: '4.4rem', fontSize: '1.5rem', fontWeight: `500` };
    });

    // スクロール
    const scroll = ref<ComponentPublicInstance<HTMLInputElement>>();
    const setScrollTo = (position: number) => {
      NativeClient.sendDebugLog("FridgeDetailsSelectDateBar setScrollTo");
      scroll.value?.scrollTo({ top: 0, left: (scroll.value?.scrollWidth / props.dateList.length) * position });
    };

    onMounted(() => {
      setScrollTo(props.selectIndex);
    });

    const leftButtonVisible = computed(() => {
      if (selectDateIndex.value == 0 && props.isDisableButtonHidden) {
        NativeClient.sendDebugLog("FridgeDetailsSelectDateBar leftButtonVisible hidden");
        return { visibility: 'hidden' };
      }
      NativeClient.sendDebugLog("FridgeDetailsSelectDateBar leftButtonVisible visible");
      return { visibility: 'visible' };
    });

    const rightButtonVisible = computed(() => {
      if (selectDateIndex.value >= (props.dateList.length - 1) && props.isDisableButtonHidden) {
        NativeClient.sendDebugLog("FridgeDetailsSelectDateBar rightButtonVisible hidden");
        return { visibility: 'hidden' };
      }
      NativeClient.sendDebugLog("FridgeDetailsSelectDateBar rightButtonVisible visible");
      return { visibility: 'visible' };
    });

    //
    // ボタンの画像
    //
    const leftButtonImage = computed(() => {
      if (selectDateIndex.value == 0) {
        return require("@/assets/images/cursor_left_disable.png");
      }
      return require("@/assets/images/cursor_left_bottom.png");
    });
    const rightButtonImage = computed(() => {
      if (selectDateIndex.value < (props.dateList.length - 1)) {
        return require("@/assets/images/cursor_right_bottom.png");
      }
      return require("@/assets/images/cursor_right_disable.png");
    });

    //
    // ボタンの処理
    //
    const leftClick = () => {
      if (selectDateIndex.value == 0) {
        // 最初の要素ならば、無視する
        return;
      }
      // 前の要素までスクロール
      selectDateIndex.value = selectDateIndex.value - 1;
      context.emit("on-select", selectDateIndex.value);
      // 前の位置までスクロール
      setScrollTo(selectDateIndex.value);
    };
    const rightClick = () => {
      if (selectDateIndex.value < (props.dateList.length - 1)) {
        // 次の要素までスクロール
        selectDateIndex.value = selectDateIndex.value + 1;
        context.emit("on-select", selectDateIndex.value);
        // 次の位置までスクロール
        setScrollTo(selectDateIndex.value);
      }
      return;
    };

    return {
      styleContentSize,
      styleItems,
      leftButtonVisible,
      leftButtonImage,
      rightButtonVisible,
      rightButtonImage,
      scroll,
      leftClick,
      rightClick
    };
  }
});
